import { normalizePhone } from "./phone";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export function phoneDigits(raw) {
  return [...String(raw || "")].filter((ch) => /\d/.test(ch)).length;
}

/** Optional phone — accepts local numbers or numbers with a leading country code. */
export function isValidPhone(raw) {
  const s = String(raw || "").trim();
  if (!s) return true;

  const plusOutsideStart = s.trim().includes("+") && !s.trimStart().startsWith("+");
  if (plusOutsideStart || (s.match(/\+/g) || []).length > 1) return false;

  const digits = phoneDigits(s);
  if (digits < 7 || digits > 15) return false;

  const normalized = normalizePhone(s);
  if (!normalized) return false;
  if (normalized.startsWith("+")) {
    const rest = normalized.slice(1);
    return /^\d+$/.test(rest) && rest.length >= 7 && rest.length <= 15;
  }
  return /^\d+$/.test(normalized);
}

export function isValidEmail(raw) {
  const s = String(raw || "").trim();
  if (!s) return true;
  if (s.length > 254) return false;
  return EMAIL_RE.test(s);
}

export function phoneValidationMessage(raw) {
  if (!String(raw || "").trim()) return null;
  return isValidPhone(raw) ? null : "Enter a valid WhatsApp number (with or without country code).";
}

export function emailValidationMessage(raw) {
  if (!String(raw || "").trim()) return null;
  return isValidEmail(raw) ? null : "Enter a valid email address.";
}

/** Validate optional phone/email fields; returns an errors object. */
export function validateOptionalContactFields(
  { phone, email } = {},
  { phoneKey = "contact_phone", emailKey = "contact_email" } = {},
) {
  const errors = {};
  const phoneMsg = phoneValidationMessage(phone);
  if (phoneMsg) errors[phoneKey] = phoneMsg;
  const emailMsg = emailValidationMessage(email);
  if (emailMsg) errors[emailKey] = emailMsg;
  return errors;
}
